'use client';

import { type ReactElement, cloneElement, forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { inputChipAvatarStyles } from './styles/input-chip-avatar.styles';
import type { InputChipAvatarPropsInterface } from './types/input-chip-avatar.types';

/**
 * @since 10.0.0
 */
export const InputChipAvatar = forwardRef<HTMLDivElement, InputChipAvatarPropsInterface>(
  (props, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(inputChipAvatarStyles, cssProp);

    const adjustedAvatar = cloneElement(children as ReactElement, {
      size: 'xs',
    });

    return (
      <span
        data-c11n-component="InputChip.Avatar"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {adjustedAvatar}
      </span>
    );
  },
);

InputChipAvatar.displayName = 'InputChip.Avatar';
